import clsx from 'clsx'
import {FC, useCallback, useEffect, useRef, useState} from 'react'
import {TOAST_EVENT, ToastMessage} from './toast'
import './toast.css'

const SUCCESS_MS = 4000
const MOST = 3

const ICONS: Record<ToastMessage['tone'], string> = {
  success: 'la-check-circle',
  danger: 'la-exclamation-circle',
  info: 'la-info-circle',
  warning: 'la-exclamation-triangle',
}

/** Shows what showToast sends, at the bottom of the screen above the phone's bottom bar (508). */
const ToastHost: FC = () => {
  const [toasts, setToasts] = useState<ToastMessage[]>([])
  const timers = useRef(new Map<number, number>())

  const close = useCallback((id: number) => {
    const timer = timers.current.get(id)
    if (timer) window.clearTimeout(timer)
    timers.current.delete(id)
    setToasts((list) => list.filter((toast) => toast.id !== id))
  }, [])

  useEffect(() => {
    const onToast = (event: Event) => {
      const toast = (event as CustomEvent<ToastMessage>).detail
      if (!toast?.text) return
      setToasts((list) => [...list.filter((item) => item.text !== toast.text), toast].slice(-MOST))
      if (toast.tone !== 'danger' && toast.tone !== 'warning') {
        timers.current.set(
          toast.id,
          window.setTimeout(() => close(toast.id), SUCCESS_MS)
        )
      }
    }
    const pending = timers.current
    window.addEventListener(TOAST_EVENT, onToast)
    return () => {
      window.removeEventListener(TOAST_EVENT, onToast)
      pending.forEach((timer) => window.clearTimeout(timer))
      pending.clear()
    }
  }, [close])

  return (
    <div className='mp-toasts' aria-live='polite'>
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={clsx('mp-toast', `mp-toast--${toast.tone}`)}
          role={toast.tone === 'danger' ? 'alert' : 'status'}
        >
          <i className={clsx('las', ICONS[toast.tone])} aria-hidden='true'></i>
          <span className='mp-toast__text'>{toast.text}</span>
          <button
            type='button'
            className='mp-toast__close'
            aria-label='بستن پیام'
            onClick={() => close(toast.id)}
          >
            <i className='las la-times' aria-hidden='true'></i>
          </button>
        </div>
      ))}
    </div>
  )
}

export {ToastHost}
